import { render, staticRenderFns } from "./MonthlyTopPerformance.vue?vue&type=template&id=0bd4ae9a&"
import script from "./MonthlyTopPerformance.vue?vue&type=script&lang=js&"
export * from "./MonthlyTopPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports